import axios from "axios";
import { base_url } from "../constants/constant";
export const Axios = axios.create({
  baseURL: base_url,
  headers: {
    "ngrok-skip-browser-warning": "69420",
  },
});
const auth = JSON.parse(localStorage.getItem("userData"));

export const authAxios = axios.create({
  baseURL: base_url,
  headers: {
    "ngrok-skip-browser-warning": "69420",
  },
});

authAxios.interceptors.request.use(
  (config) => {
    const auth = JSON.parse(localStorage.getItem("userData"));
    if (auth?.access_token) {
      config.headers.Authorization = `Bearer ${auth.access_token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);
